import $ from 'jquery';

class Cookies {
    constructor() {
        this.bindClick();
    }

    bindClick() {
        $(document).ready(() => {
            $('.cookies__accept').click(function () {
                const date = new Date();
                date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
                document.cookie = 'cinfo=1; path=/; expires=' + date.toGMTString();
                $('#cookies').fadeOut();
            });
        });

        $("[data-setCookie]").on("click", (event) => {
            const name = $(event.currentTarget).attr("data-setCookie");
            const value = $(event.currentTarget).attr("data-cookieValue");
            const date = new Date();
            date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));

            document.cookie = `${name}=${value}; path=/; expires=${date.toGMTString()}`;
        });
    }
}

export default new Cookies();
